import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import coach from './coach';
import trainer from './trainer';
import trainerApply from './trainer_apply';
import calendar from './calendar';
import course from './course';
import share from './share';
import wechat from './wechat';


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        coach,
        trainer,
        trainer_apply: trainerApply,
        calendar,
        course,
        share,
        wechat,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js